// extracted by mini-css-extract-plugin
export var container = "_kf-0";
export var dotAnimation = "_kf-2";
export var dotsLoading = "_kf-1";